import VueApollo from 'vue-apollo'
import {ApolloClient} from 'apollo-client'
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {ApolloLink} from 'apollo-link'
import store from './store/index'

var cache = new InMemoryCache({
    dataIdFromObject: o => {
        o.id ? `${o.__typename}-${o.id}` : `${o.__typename}-${o.cursor}`
    },
})

var middlewareLink = new ApolloLink((operation, forward) => {
    const token = store.state.oidcStore.access_token;
    operation.setContext({
        headers: {
            Authorization: `Bearer ${token}` || null,
        }
    })
    return forward(operation)
})

var defaultOptions = {
    watchQuery: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
    },
    query: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
    },
    mutate: {
        errorPolicy: 'all',
    },
};
var knowledgeHttpLink = createHttpLink({
    uri: window.commonApi.KNOWLEDGE_URL,
})

var taskapiHttpLink = createHttpLink({
    uri: window.commonApi.TASKAPI_URL,
})

var taskcenterapiHttpLink = createHttpLink({
    uri: window.commonApi.TASKCENTER_API_URL + '/graphql'
})

var knowledgeLinkStr = middlewareLink.concat(knowledgeHttpLink);
var knowledgeApolloClient = new ApolloClient({
    link: knowledgeLinkStr,
    cache: cache
})

var taskapiLinkStr = middlewareLink.concat(taskapiHttpLink);
var taskapiApolloClient = new ApolloClient({
    link: taskapiLinkStr,
    cache: cache
})

var taskcenterapiLinkStr = middlewareLink.concat(taskcenterapiHttpLink);
var taskcenterapiApolloClient = new ApolloClient({
    link: taskcenterapiLinkStr,
    cache: cache
})

window.apolloProvider = new VueApollo({
    clients: {
        knowledge: knowledgeApolloClient,
        taskapi: taskapiApolloClient,
        taskcenterapi: taskcenterapiApolloClient,
    },
    defaultClient: knowledgeApolloClient
})


export default apolloProvider


// WEBPACK FOOTER //
// ./src/apolloConfig.js